import { Link } from 'react-router-dom';
import type { V2Scribe } from './content';

export function Scribe({ content }: { content: V2Scribe }) {
  return (
    <section className="v2-section v2-scribe">
      <div className="v2-container v2-scribe-grid">
        <div className="v2-scribe-copy">
          <span className="v2-eyebrow v2-eyebrow-lime" data-reveal>
            <i className="ph ph-sparkle" aria-hidden="true" />
            {content.eyebrow}
          </span>
          <h2 className="v2-h2" data-reveal data-reveal-delay="0.08">
            {content.title} <em className="v2-serif-accent v2-accent-lime">{content.accent}</em>
          </h2>
          <p className="v2-body" data-reveal data-reveal-delay="0.16">
            {content.body}
          </p>
          <Link to={content.cta.href} className="v2-btn v2-btn-lime" data-reveal data-reveal-delay="0.24">
            {content.cta.label}
            <i className="ph ph-arrow-right" aria-hidden="true" />
          </Link>
        </div>

        <div className="v2-scribe-screen" data-reveal data-reveal-delay="0.12">
          <header className="v2-scribe-screenhead">
            <span className="v2-frame-dots v2-frame-dots-dark" aria-hidden="true">
              <i />
              <i />
              <i />
            </span>
            <span>{content.noteHeading}</span>
          </header>

          <div className="v2-scribe-listening">
            <span className="v2-eq v2-eq-lime" aria-hidden="true">
              <i />
              <i />
              <i />
              <i />
              <i />
              <i />
              <i />
            </span>
            <span className="v2-scribe-listening-text">{content.listening}</span>
          </div>

          <ul className="v2-scribe-note">
            {content.noteLines.map((line, index) => (
              <li className="v2-note-line" key={line}>
                <i className="ph ph-check-circle" aria-hidden="true" />
                <span>{line}</span>
                {index === content.noteLines.length - 1 ? <span className="v2-caret" aria-hidden="true" /> : null}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
